import React from 'react';
const IconMiscBoltAltFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.99996 23.66L20.54 9.90997H15V0.159973L3.45996 13.91H8.99996V23.66Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscBoltAltFill;